/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateStockAdjustmentDto } from '../../models/create-stock-adjustment-dto';
import { StockAdjustment } from '../../models/stock-adjustment';

export interface StockAdjustmentsControllerCreate$Params {
      body: CreateStockAdjustmentDto
}

export function stockAdjustmentsControllerCreate(http: HttpClient, rootUrl: string, params: StockAdjustmentsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<StockAdjustment>> {
  const rb = new RequestBuilder(rootUrl, stockAdjustmentsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StockAdjustment>;
    })
  );
}

stockAdjustmentsControllerCreate.PATH = '/stock/adjustments';
